import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Loading from '../../../components/common/Loading';
import Tabs from '../../../components/common/Tabs';
import VacancyForm from '../../../components/module/rec/vacancy/VacancyForm';
import VacancyJDForm from '../../../components/module/rec/vacancy/VacancyJDForm';
import VacancyUploadForm from '../../../components/module/rec/vacancy/VacancyUploadForm';
import api from '../../../utils/api';

const AddVacancy: React.FC = () => {
  const [tabs, setTabs] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);
  const [addedVacancyId, setAddedVacancyId] = useState<number | null>(null);

  useEffect(() => {
    const fetchTabs = async () => {
      try {
        setIsLoading(true);
        const response = await api<{ data: any[] }>({
          method: 'GET',
          url: `/cmn/menu/tab/${10}`,
        });
        setActiveTab(response.data.data[0].menuId);
        setTabs((response.data.data ?? []).map((tab, index) => ({
          label: tab.name,
          value: tab.menuId,
          // disabled: index !== 0
        })));
      } catch (error) {
        console.error('Error fetching tabs:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTabs();
  }, []);

  useEffect(() => {
    if (addedVacancyId) {
      setTabs((prevTabs) => prevTabs.map((tab) => ({
        ...tab,
        disabled: false
      })));
    }
  }, [addedVacancyId]);

  const handleTabChange = (value: any) => {
    setActiveTab(value);
  };

  const renderContent = () => {
    switch (activeTab) {
      case tabs[0]?.value:
        return <VacancyForm type="add" onCancel={() => { }} onSave={() => { }} setAddedVacancyId={setAddedVacancyId} />;
      case tabs[1]?.value:
        return <VacancyJDForm type="add" onCancel={() => { }} onSave={() => { }} />;
      case tabs[2]?.value:
        return <VacancyUploadForm type="add" onCancel={() => { }} onSave={() => { }} />;
      default:
        return null;
    }
  };

  return (
    <Box className="page-container" p={3}>
      {isLoading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
          <Loading />
        </Box>
      ) : (
        <>
            <Typography className="page-title" mb={3}>
              Add Vacancy
            </Typography>
            <Box mb={3}>
              <Tabs
                tabs={tabs}
                value={activeTab}
                onChange={handleTabChange}
              />
            </Box>
            {renderContent()}
        </>
      )}
    </Box>
  );
};

export default AddVacancy; 